import React, { useCallback, useEffect, useState } from 'react'
import { Translate } from 'react-localize-redux'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom'
import { canBeEditInternalUserInformation, canBeEditSupplierInformation } from '../../store/helpers/LoadAlertHelper'
import { IsCurrentActiveDirectoryUser } from '../../store/helpers/SessionHelper'
import {
    AddPreviousOrigin,
    UpdateLoadAlert,
    UpdateLoadAlertItem,
    deleteFilesLoadAlert,
    loadAlertFromBack,
    sendNotificationToSupplier,
    uploadFilesLoadAlert,
} from '../../store/loadAlerts/LoadAlertAction'
import LateralPanelContainer from '../common/LateralPanelComponents/LateralPanelContainer'
import Toaster from '../common/Toaster'
import withauthenticatedLayout from '../layouts/withauthenticatedLayout'
import AddAnnexesDocumentes from './componentes/AddAnnexesDocumentes'
import AddInspectionDocument from './componentes/AddInspectionDocument'
import AddInvoiceDocuments from './componentes/AddInvoiceDocuments'
import AddLoadAlert from './componentes/AddLoadAlert'
import AddMaterial from './componentes/AddMaterial'
import DesktopView from './componentes/show/DesktopView'

const Show = (props) => {
	const params = useParams()
	let history = useHistory()
	const dispatch = useDispatch()
	const [tab, setTab] = useState('1')
	const [identifierPanelLateral, setIdentifierPanelLateral] = useState('')
	let userRolesByCompany = useSelector((state) => state.profile.get('userRolesByCompany').toJS())
	const isLoading = useSelector((state) =>
		state.loadAlert.get('isLoading') ? state.loadAlert.get('isLoading') : false
	)

	const loadAlert = useSelector((state) =>
		state.loadAlert.get('loadAlert') ? state.loadAlert.get('loadAlert').toJS() : []
	)
	const supplier = useSelector((state) =>
		state.suppliers.get('supplier') ? state.suppliers.get('supplier').toJS() : null
	)
	const userProfile = useSelector((state) => state.oidc.user)
	const nacionalData = loadAlert && loadAlert.items ? loadAlert.items.find((x) => x.type === 2) : null
	const internacionalData = loadAlert && loadAlert.items ? loadAlert.items.find((x) => x.type === 1) : null
	const previousOriginData = loadAlert && loadAlert.items ? loadAlert.items.find((x) => x.type === 3) : null
	let isInternalUser = IsCurrentActiveDirectoryUser(userProfile)

	let canbeUpdateSupplierInternational = canBeEditSupplierInformation(
		loadAlert,
		userRolesByCompany,
		userProfile,
		internacionalData
	)

	let canbeUpdateSupplierNacional = canBeEditSupplierInformation(
		loadAlert,
		userRolesByCompany,
		userProfile,
		nacionalData
	)
	let canbeUpdateSupplierPreviousOrigin = canBeEditSupplierInformation(
		loadAlert,
		userRolesByCompany,
		userProfile,
		previousOriginData
	)

	let canBeEditInternalUserData = canBeEditInternalUserInformation(
		loadAlert,
		userRolesByCompany,
		userProfile,
		isInternalUser
	)

	let supplierLogo = supplier ? supplier.logo : ''
	let urlImageSupplier = `${process.env.REACT_APP_IDENTITY_SERVER}${supplierLogo}`
	/** Get user Information*/
	const [toasterMessageConfig, setToasterMessageConfig] = useState({
		showToaster: false,
		toasterMessage: null,
		toasterVariant: '',
		name: '',
	})

	useEffect(() => {
		dispatch(loadAlertFromBack(params.token)) //sortCriteria.by
	}, [dispatch])

	useEffect(() => {
		if (tab === '1' && internacionalData)
			history.push(`/loadAlerts/${params.token}/${internacionalData.token}`)
		if (tab === '2' && nacionalData)
			history.push(`/loadAlerts/${params.token}/${nacionalData.token}`)
		if (tab === '3' && previousOriginData)
			history.push(`/loadAlerts/${params.token}/${previousOriginData.token}`)
	}, [tab])

	const addPreviousOriging = () => {
		return dispatch(AddPreviousOrigin(params.token))
			.then(() => {
				setToasterMessageConfig({
					showToaster: true,
					toasterVariant: 'success',
					toasterMessage: 'common.addCorrectly',
				})
			})
			.catch(() => {
				setToasterMessageConfig({
					showToaster: true,
					toasterMessage: 'common.errorToAdd',
					toasterVariant: 'error',
				})
			})
	}
	const onUpdateRequest = (objectProperties) => {
		return dispatch(UpdateLoadAlert(objectProperties))
			.then(() => {
				setToasterMessageConfig({
					showToaster: true,
					toasterVariant: 'success',
					toasterMessage: 'common.saveCorrectly',
				})
			})
			.catch(() => {
				setToasterMessageConfig({
					showToaster: true,
					toasterMessage: 'common.error',
					toasterVariant: 'error',
				})
			})
	}

	const onSendNotificationToSupplier = (itemToken) => {
		return dispatch(sendNotificationToSupplier(loadAlert.token, itemToken))
			.then(() => {
				setToasterMessageConfig({
					showToaster: true,
					toasterVariant: 'success',
					toasterMessage: 'common.send',
				})
			})
			.catch(() => {
				setToasterMessageConfig({
					showToaster: true,
					toasterMessage: 'common.error',
					toasterVariant: 'error',
				})
			})
	}

	const updateLoadAlertItemProperty = (objectProperties) => {
		return dispatch(UpdateLoadAlertItem(objectProperties))
			.then(() => {
				setToasterMessageConfig({
					showToaster: true,
					toasterVariant: 'success',
					toasterMessage: 'common.saveCorrectly',
				})
			})
			.catch(() => {
				setToasterMessageConfig({
					showToaster: true,
					toasterMessage: 'common.error',
					toasterVariant: 'error',
				})
			})
	}

	const onUploadInspectionDocument = (files) => {
		return dispatch(uploadFilesLoadAlert(loadAlert.token, files, 'InspectionDocument', 'inspectionDocument'))
	}
	const onUploadInvoiceDocument = (files) => {
		return dispatch(uploadFilesLoadAlert(params.item, files, 'InvoiceDocument', 'invoiceDocument'))
	}
	const onUploadAnnexesDocument = (files) => {
		return dispatch(uploadFilesLoadAlert(params.item, files, 'AnnexesDocument', 'annexesDocument'))
	}
	const deleteAnnexesFiles = (name) => {
		return dispatch(deleteFilesLoadAlert(params.item, 'AnnexesDocument', name))
	}

	const onLateralPanelConfig = (identifier) => {
		setIdentifierPanelLateral(identifier)
		onOpenAndCloseLateralPanel()
	}

	const PanelLateralChildren = useCallback(
		{
			AddLoadAlert: <AddLoadAlert onCloseModal={() => onOpenAndCloseLateralPanel()} />,
			AddMaterial: <AddMaterial onCloseModal={() => onOpenAndCloseLateralPanel()} />,
			AddInspectionDocument: (
				<AddInspectionDocument
					onCloseModal={() => onOpenAndCloseLateralPanel()}
					onUploadInspectionDocument={onUploadInspectionDocument}
				/>
			),
			AddAnnexesDocumentes: (
				<AddAnnexesDocumentes
					onCloseModal={() => onOpenAndCloseLateralPanel()}
					onUploadAnnexesDocument={onUploadAnnexesDocument}
					deleteAnnexesFiles = {deleteAnnexesFiles}
				/>
			),
			AddInvoiceDocuments: (
				<AddInvoiceDocuments
					onCloseModal={() => onOpenAndCloseLateralPanel()}
					onUploadInvoiceDocument={onUploadInvoiceDocument}
				/>
			),
		},
		[identifierPanelLateral]
	)
	const { LateralPanelComponent, onOpenAndCloseLateralPanel } = LateralPanelContainer({
		children: PanelLateralChildren[identifierPanelLateral],
		identifier: identifierPanelLateral,
	})

	return (
		<>
			<DesktopView
				//array props section
				userRolesByCompany={userRolesByCompany}
				//functions props section
				onLateralPanelConfig={onLateralPanelConfig}
				onUpdateRequest={onUpdateRequest}
				addPreviousOriging={addPreviousOriging}
				updateLoadAlertItemProperty={updateLoadAlertItemProperty}
				onSendNotificationToSupplier={onSendNotificationToSupplier}
				deleteAnnexesFiles={deleteAnnexesFiles}
				//bool props section
				canbeUpdateSupplierInternational={canbeUpdateSupplierInternational}
				canbeUpdateSupplierNacional={canbeUpdateSupplierNacional}
				canbeUpdateSupplierPreviousOrigin={canbeUpdateSupplierPreviousOrigin}
				isLoading={isLoading}
				canBeEditInternalUserData={canBeEditInternalUserData}
				//string props section
				supplierLogo={supplierLogo}
				urlImageSupplier={urlImageSupplier}
				tab={tab}
				setTab={setTab}
				identifierPanelLateral={identifierPanelLateral}
				//object
				params={params}
				loadAlert={loadAlert}
				supplier={supplier}
				previousOriginData={previousOriginData}
				userProfile={userProfile}
				nacionalData={nacionalData}
				internacionalData={internacionalData}
			/>
			<LateralPanelComponent />
			<Toaster
				message={<Translate id={toasterMessageConfig.toasterMessage} />}
				open={toasterMessageConfig.showToaster}
				variant={toasterMessageConfig.toasterVariant}
				onClose={() => {
					setToasterMessageConfig({
						showToaster: false,
						toasterMessage: '',
						toasterVariant: '',
					})
				}}
			/>
		</>
	)
}

export default withauthenticatedLayout(Show)
